<template>
  <div style="width: 876px;">
    <h1 style="margin-top:12px"
        class="title">更新日志</h1>
    <span class="time">最后更新时间：2021年08月31日</span>
    <div class="update-log-container">
      <el-row style="border-bottom:1px solid #e7e7e7; padding-bottom:20px">
        <el-col :span='12'>
          <h2>美团地图 V1.0.0 上线</h2>
        </el-col>
        <el-col :span='12'
                style="text-align:right">
          <h2>2021年8月31日</h2>
        </el-col>
      </el-row>
      <p>
      <ol style="margin: 15px 0 0 15px; padding:0;">
        <li>
          <p>我们更新了搜索服务：周边搜索，多边形搜索接口技术文档。</p>
        </li>
        <li>
          <p>我们更新了路线规划服务：驾车路线规划，步行路线规划，骑行路线规划，电动车路线规划接口技术文档。</p>
        </li>
        <li>
          <p>我们更新了行政区域查询服务：行政区域查询技接口术文档。</p>
        </li>
        <li>
          <p>我们更新了地图匹配服务：地图匹配接口技术文档。</p>
        </li>
      </ol>
      </p>
    </div>

  </div>

</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style scoped>
@import './document.less';
</style>
